import { useSidebarSummaryContext } from '../../../../../../SidebarSummary.context';
import type { RankingAnimationProps } from '../../RankingAnimation';
import {
  StyledBasicTitle,
  StyledBiggerSubtitle,
  StyledImage,
  Wrapper,
} from './ErrorRankingAnimation.styled';

export const ErrorRankingAnimation = ({
  hideAnimation,
  onAnimationEnd,
}: RankingAnimationProps) => {
  const {
    state: { isOpen },
    config: { getTranslation },
  } = useSidebarSummaryContext();

  const handleAnimationEnd = () => {
    if (onAnimationEnd && hideAnimation) {
      onAnimationEnd();
    }
  };

  return (
    <Wrapper $activeHideAnimation={hideAnimation} onAnimationEnd={handleAnimationEnd}>
      <StyledImage
        src="https://static.genially.com/genially/activities/fail"
        $activeAnimation={isOpen}
      />
      <StyledBasicTitle $activeAnimation={isOpen}>
        {getTranslation('__new.content.interactiveQuestion.sidebar.wrongAnswer.title')}
      </StyledBasicTitle>
      <StyledBiggerSubtitle $activeAnimation={isOpen}>
        {getTranslation('__new.content.interactiveQuestion.sidebar.wrongAnswer.subtitle')}
      </StyledBiggerSubtitle>
    </Wrapper>
  );
};
